import { getTCaptchaJs, sendCodeV3, sendCodeV4 } from '../service/getData';
export const captcha = {
	data() {
		return {
			captchaMobile: '',
			captchaObj: {
				appid: '',
				randstr: '',
				url: ''
			}
		};
	},
	methods: {
		// 获取滑动验证码接口
		async getTCaptchaJs(mobile, callBack) {
			this.captchaMobile = mobile;
			const { data } = await getTCaptchaJs();
			if (data.code == 1) {
				this.captchaObj = data.result;
				this.loadJS(callBack);
			}
		},

		// 插入script标签
		loadJS(callBack) {
			let _this = this;
			let captchaObj = this.captchaObj;
			let src = this.captchaObj.url;
			let script_dom = document.createElement('script');
			script_dom.src = src;
			script_dom.language = 'javascript';
			script_dom.type = 'text/javascript';
			let head = document.getElementsByTagName('head').item(0);
			head.appendChild(script_dom);
			let captchaContainer = document.getElementById('TCaptcha');
			script_dom.onload = function () {
				try {
					let captcha = new TencentCaptcha(captchaContainer, captchaObj.appid, captchaCallback);
					captcha.show();
				} catch (error) {
				}
				// 回调函数：验证码页面关闭时回调
				function captchaCallback(res) {
					if (res.ret == 0 && res.ticket) {
						_this.sendCodeV3(res, callBack);
						destroy();
					} else {
						destroy();
					}
				}
			};
		},
		// 发送短信验证码
		async sendCodeV3(captchaRes, callBack) {
			let params = {
				mobile: this.captchaMobile,
				ticket: captchaRes.ticket,
				businessNo: this.$store.state.businessNo,
				businessId: '1',
				randstr: captchaRes.randstr
			};
			const { data } = await sendCodeV3(params);
			callBack && callBack(data);
		},
		// 发送短信验证码v4
		async sendCodeV4(mobile, callBack) {
			this.captchaMobile = mobile;
			let params = {
				mobile: this.captchaMobile,
				businessNo: this.$store.state.businessNo,
				businessId: '1'
			};
			const { data } = await sendCodeV4(params);
			callBack && callBack(data);
		}
	}
};



// WEBPACK FOOTER //
// ./src/js/captcha.js